import { Button, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import SnackBar from '../../General/SnackBar';
import BackdropLoader from '../../General/Loader';
import { HandleSubmitVendorDetails } from 'API/Procurement/VendorApis';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
});

const DocumentForm = (props) => {
  const [AlertOpen, setAlertOpen] = useState(false);
  const [AlertMsg, setAlertMsg] = useState('');
  const [AlertType, setAlertType] = useState('success');
  const [IsLoading, setIsLoading] = useState(false);

  const handleFileUpload = (name, file) => {
    if (!file) {
      console.error('No file provided.');
      return;
    }

    const allowedExtensions = /\.(jpeg|jpg|png|pdf)$/i;
    const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB

    if (!allowedExtensions.test(file.name)) {
      handleAlertOpen('Invalid file type. Please upload a JPEG, JPG, PDF or PNG file.', 'error');
      return;
    }

    console.log('file size', file.size, maxSizeInBytes);

    if (file.size > maxSizeInBytes) {
      handleAlertOpen('File size exceeds the 5MB limit.', 'error');
      return;
    }

    // If validation passes, update the state
    props.setFileData({ ...props.data, [name]: file });
  };

  const handleClose = () => {
    setAlertOpen(false);
  };

  const handleAlertOpen = (message, type) => {
    setAlertMsg(message);
    setAlertType(type);
    setAlertOpen(true);
  };

  console.log(props.data);

  const handleSubmit = () => {
    if (props.data && props.data.pan_card && props.data.gst_no && props.data['passbook/cancelled_cheque']) {
      console.log(props.postData);
      HandleSubmitVendorDetails(props.postData, props.data, setIsLoading, handleAlertOpen);
    } else {
      handleAlertOpen('Please upload all the files', 'error');
    }
  };

  return (
    <Grid container>
      <SnackBar open={AlertOpen} message={AlertMsg} type={AlertType} handleClose={handleClose} />
      <BackdropLoader open={IsLoading} />
      <Grid container xs={6} paddingBlock={2}>
        <Typography color="error" variant="h6">
          *Documents must be in .JPEG, .JPG, .PDF or .PNG format and their size must be below 5 MB.
        </Typography>
        <table>
          <tr>
            <td style={{ paddingBlock: '5px' }}>Pan card</td>
            <td style={{ paddingBlock: '5px' }}>
              <Button
                component="label"
                role={undefined}
                sx={{
                  backgroundColor: '#592375',
                  color: '#FFFFFF',
                  borderRadius: '6px',
                  '&:hover': {
                    backgroundColor: '#592375'
                  }
                }}
                variant="contained"
                color="secondary"
                tabIndex={-1}
                size="small"
              >
                {props.data && props.data['pan_card'] ? 'Uploaded' : 'Upload'}
                <VisuallyHiddenInput type="file" onChange={(event) => handleFileUpload('pan_card', event.target.files[0])} multiple />
              </Button>
            </td>
            {props.data && props.data['pan_card'] && (
              <td style={{ paddingBlock: '5px' }}>
                <Button
                  variant="outlined"
                  sx={{
                    borderColor: '#592375',
                    color: '#592375',
                    borderRadius: '6px',
                    '&:hover': {
                      borderColor: '#592375'
                    }
                  }}
                  size="small"
                  color="secondary"
                  onClick={() => props.handleOpenImage(props.data['pan_card'])}
                >
                  View
                </Button>
              </td>
            )}
          </tr>
          <tr>
            <td style={{ paddingBlock: '5px' }}>GST Certificate</td>
            <td style={{ paddingBlock: '5px' }}>
              <Button
                component="label"
                role={undefined}
                variant="contained"
                sx={{
                  backgroundColor: '#592375',
                  color: '#FFFFFF',
                  borderRadius: '6px',
                  '&:hover': {
                    backgroundColor: '#592375'
                  }
                }}
                color="secondary"
                tabIndex={-1}
                size="small"
              >
                {props.data && props.data['gst_no'] ? 'Uploaded' : 'Upload'}
                <VisuallyHiddenInput type="file" onChange={(event) => handleFileUpload('gst_no', event.target.files[0])} multiple />
              </Button>
            </td>
            {props.data && props.data['gst_no'] && (
              <td style={{ paddingBlock: '5px' }}>
                <Button
                  variant="outlined"
                  size="small"
                  sx={{
                    borderColor: '#592375',
                    color: '#592375',
                    borderRadius: '6px',
                    '&:hover': {
                      borderColor: '#592375'
                    }
                  }}
                  color="secondary"
                  onClick={() => props.handleOpenImage(props.data['gst_no'])}
                >
                  View
                </Button>
              </td>
            )}
          </tr>
          <tr>
            <td style={{ paddingBlock: '5px' }}>Copy of Passbook/Cancelled cheque</td>
            <td style={{ paddingBlock: '5px' }}>
              <Button
                component="label"
                role={undefined}
                sx={{
                  backgroundColor: '#592375',
                  color: '#FFFFFF',
                  borderRadius: '6px',
                  '&:hover': {
                    backgroundColor: '#592375'
                  }
                }}
                variant="contained"
                color="secondary"
                tabIndex={-1}
                size="small"
              >
                {props.data && props.data['passbook/cancelled_cheque'] ? 'Uploaded' : 'Upload'}
                <VisuallyHiddenInput
                  type="file"
                  onChange={(event) => handleFileUpload('passbook/cancelled_cheque', event.target.files[0])}
                  multiple
                />
              </Button>
            </td>
            {props.data && props.data['passbook/cancelled_cheque'] && (
              <td style={{ paddingBlock: '5px' }}>
                <Button
                  variant="outlined"
                  sx={{
                    borderColor: '#592375',
                    color: '#592375',
                    borderRadius: '6px',
                    '&:hover': {
                      borderColor: '#592375'
                    }
                  }}
                  size="small"
                  color="secondary"
                  onClick={() => props.handleOpenImage(props.data['passbook/cancelled_cheque'])}
                >
                  View
                </Button>
              </td>
            )}
          </tr>
        </table>
      </Grid>
      <Grid container xs={12}>
        <Stack direction="row" justifyContent="space-between" width="100%">
          <Button
            variant="outlined"
            color="secondary"
            sx={{
              minWidth: '150px',
              mr: 1,
              borderColor: '#688B3A',
              color: '#688B3A',
              borderRadius: '6px',
              '&:hover': {
                borderColor: '#688B3A'
              }
            }}
            onClick={props.handleBack}
            size='medium'
          >
            Back
          </Button>
          <Button
            variant="contained"
            color="secondary"
            sx={{
              minWidth: '150px',
              mr: 1,
              backgroundColor: '#688B3A',
              color: '#FFFFFF',
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: '#688B3A'
              }
            }}
            onClick={() => handleSubmit()}
            size='medium'
          >
            Submit
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default DocumentForm;
